import { List, Map } from 'immutable';
import Response from '../records/Response';
var path = 'taking';
export var getCurrentSessionItemPosition = function getCurrentSessionItemPosition(state) {
  return state.getIn([path, 'currentSessionItemPosition'], 1);
};
export var getBrowserSessionId = function getBrowserSessionId(state) {
  return state.getIn([path, 'browserSessionId']);
};
export var getIpAddress = function getIpAddress(state) {
  return state.getIn([path, 'ipAddress']);
};
export var getTimerData = function getTimerData(state) {
  return state.getIn([path, 'timerData'], Map());
};
export var getIsTaking = function getIsTaking(state) {
  return state.getIn([path, 'isTaking']);
};
export function isTimeUp(state) {
  var timerRunning = state.getIn([path, 'timerData', 'timerRunning']);
  var noTimeLeft = state.getIn([path, 'timerData', 'timeLeftInSeconds']) <= 0;
  return noTimeLeft && timerRunning;
}
export function getResponsesByIds(state) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ids.reduce(function (list, id) {
    var response = getResponseById(state, id);
    return response ? list.push(response) : list;
  }, List());
}
export function getResponseById(state, id) {
  return Response.create(state.getIn([path, 'responses', id]));
}
export function getResponseDataByPosition(state, position) {
  return state.getIn([path, 'responses', position]);
}